<script setup>

const filters = defineModel({ type: Object, default: { availableObjects: [], objects: [], startDate: null, endDate: null, onlyError: undefined, onlyRecords: true, selectedButtons: ['onlyRecords'] } })

const getOptions = () => {
  const opt = []
  if (filters.value.onlyError) { opt.push({ name: 'Errors', value: 'onlyError' }) }
  if (filters.value.onlyRecords) { opt.push({ name: 'Relevant', value: 'onlyRecords' }) }
  return opt
}

</script>

<template>
  <div class="flex flex-col lg:flex-row md:p-3 gap-4 justify-end">
    <div
      v-if="filters.onlyError !== undefined || filters.onlyRecords!== undefined"
      class="w-full lg:w-min flex-shrink-0"
    >
      <SelectButton
        v-model="filters.selectedButtons"
        :options="getOptions()"
        option-label="name"
        option-value="value"
        class="flex justify-center w-full"
        multiple
      />
    </div>
    <div
      v-if="filters.availableObjects"
      class="flex-grow min-w-0 flex-shrink"
    >
      <MultiSelect
        v-model="filters.objects"
        aria-label="Select Objects"
        input-id="multipiclisktobject"
        class="w-full"
        display="chip"
        :options="filters.availableObjects"
        filter
        :max-selected-labels="1"
        placeholder="Select Objects"
      />
    </div>
    <div class="w-full lg:w-52 flex-shrink-0">
      <FloatLabel variant="on">
        <DatePicker
          v-model="filters.startDate"
          input-id="startdate"
          :input-attr="{required: 'true'}"
          class="w-full"
          :max-date="new Date()"
          :invalid="filters.startDate === null"
          date-format="dd/mm/yy"
          show-icon
          show-time
          hour-format="24"
        />
        <label for="startdate">Start Date</label>
      </FloatLabel>
    </div>
    <div class="w-full lg:w-52 flex-shrink-0">
      <FloatLabel variant="on">
        <DatePicker
          v-model="filters.endDate"
          input-id="enddate"
          class="w-full"
          date-format="dd/mm/yy"
          :min-date="filters.startDate"
          show-icon
          show-time
          hour-format="24"
          fluid
        />
        <label for="enddate">End Date</label>
      </FloatLabel>
    </div>
  </div>
</template>
